import { immer } from "zustand/middleware/immer";

import { reverseSearchPlaces } from "@/api";
import { GeoLocation } from "@/types";
import { createStore } from "@/utils";

type AppState = {
  geoLocation?: GeoLocation;
  notificationsCounter: number;
  isSubscribed?: boolean;
};

type AppActions = {
  actions: {
    tryEnableGeo: () => void;
    changeNotificationCounter: (newValue: AppState["notificationsCounter"]) => void;
    changeSubscription: (newValue: AppState["isSubscribed"]) => void;
    increaseNotificationCounter: () => void;
    decreaseNotificationCounter: () => void;
  };
};

const defaultAppValues: AppState = {
  notificationsCounter: 0,
};

const useAppStore = createStore<AppState & AppActions>(
  immer((set) => ({
    ...defaultAppValues,
    actions: {
      tryEnableGeo: async () => {
        if (navigator.permissions) {
          const { state } = await navigator.permissions.query({ name: "geolocation" });

          if (state === "granted" || state === "prompt") {
            navigator.geolocation.getCurrentPosition(async ({ coords: { longitude, latitude } }) => {
              const geoPlaces = await reverseSearchPlaces({ coordinates: [longitude, latitude] });

              set((state) => {
                if (geoPlaces[0]) {
                  state.geoLocation = {
                    type: "Point",
                    label: geoPlaces[0].label,
                    coordinates: geoPlaces[0].coordinates,
                  };
                }
              });
            });
          }
        }
      },
      changeSubscription: (newValue) => {
        set((state) => {
          state.isSubscribed = newValue;
        });
      },
      changeNotificationCounter: (newValue) => {
        set((state) => {
          state.notificationsCounter = newValue;
        });
      },
      increaseNotificationCounter: () => {
        set((state) => {
          state.notificationsCounter += 1;
        });
      },
      decreaseNotificationCounter: () => {
        set((state) => {
          state.notificationsCounter -= 1;
        });
      },
    },
  }))
);

export { useAppStore };
